<template>
  <div class="Evaluation-modal-overlay">
    <div class="Evaluation-modal" @click.stop>
      <div class="modal-content">
        <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
        <h3 style="font-size: 1.5rem; margin-bottom: 10px;">Continuous Evaluation</h3>
        <div class="container-fluid">
            <div v-if="!hasMetTaskRequirement" class="flex-grow-1 d-flex justify-content-center" style="margin-bottom: 20px;">
                <div class="expired-box" style="margin-top:10px;">
                    Minimum {{ minTasksRequired }} main tasks are required to submit this evaluation. You have completed {{ completedTasks }} main tasks.
                </div>
            </div>
          <div class="table-responsive">
            <table class="evaluation-table">
              <thead>
                <tr>
                  <th style="min-width: 120px;">{{ $labels.licenseNo }}</th>
                  <th style="min-width: 200px;">Name</th>
                  <th v-for="col in evaluationColumns" :key="col.key" style="min-width: 160px;">
                    {{ col.label }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <!-- <tr v-for="(trainee, index) in trainees" :key="trainee.user_id"
                  :class="{ 'missing-task': isTraineeMissingTask(trainee.user_id) }"> -->
                  <td>{{ trainee.license_no }}</td>
                  <td>{{ trainee.first_name + ' ' + trainee.last_name }}</td>
                <td v-for="col in evaluationColumns" :key="col.key" style="text-align:center;">
                  <button
                    v-if="shouldShowEvaluationButton(col.key)"
                    class="assess-button"
                    :class="getEvaluationButtonClass(col.key)"
                    @click="openEvaluationModal(col.key)"
                  >
                    {{ getEvaluationButtonLabel(col.key) }}
                  </button>
                </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="button-container">
          <button class="ins-close-button" @click="close()">Close</button>
        </div>
        <evaluation-modal v-if="showEvaluationModal" :tasks-count="tasksCount" :completed-tasks="completedTasks"
            :propTasks="propTasks" :evaluation-id="selectedEvaluationId" :parent-evaluation-id="selectedParentEvaluationId" :logbook-id="logbookId" :trainee="trainee" :fetched-data="selectedFetchedEvaluationData"
            :evaluation-type="selectedEvaluationType" :passRate="passRate ?? 50" :locked="locked" mode="trainee" @close="closeEvaluationModal()"></evaluation-modal>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import EvaluationModal from '@/components/Instructor/EvaluationModal.vue';
import { ENFORCE_EVALUATION_MIN_TASKS } from '@/config/featureFlags';


export default {
  name: 'ChooseEvaluationModal',
  components: {
    EvaluationModal,
  },
  props: {
    tasksCount: {
      type: Number,
      required: true
    },
    completedTasks: {
      type: Number,
    },
    evaluationId: Number,
    logbookId: Number,
    locked: Boolean,
    propTasks: {
      type: Array,
      required: true
    },
    trainee: {
        type: Object,
        required: true
    },
    passRate: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
        showEvaluationModal: false,
        MTCount: '',
        completedMTCount: '',
        trainee_evaluations: [],
        selectedEvaluationType: 'continuous',
        selectedParentEvaluationId: null,
        selectedEvaluationId: null,
        selectedFetchedEvaluationData: null,
    };
  },
  computed: {
    evaluationColumns() {
    return [
        { key: 'continuous', label: 'Continuous Evaluation' },
        { key: 'remedial', label: 'Remedial Evaluation' }
    ];
    },
    continuousEvaluation() {
        return this.trainee_evaluations.find(e => e.evaluation_type === 'continuous') || null;
    },
    remedialEvaluation() {
        return this.trainee_evaluations.find(e => e.evaluation_type === 'remedial') || null;
    },
    canStartRemedial() {
        return !!(
            this.continuousEvaluation &&
            this.continuousEvaluation.is_submitted === 2 &&
            this.continuousEvaluation.result === 'remedial' &&
            !this.remedialEvaluation
        );
    },
    minTasksRequired() {
      return Math.ceil(this.tasksCount * (this.passRate / 100));
    },
    hasMetTaskRequirement() {
      if (!ENFORCE_EVALUATION_MIN_TASKS) return true;
      return this.completedTasks === null || this.completedTasks >= this.minTasksRequired;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    shouldShowEvaluationButton(type) {
      const data = this.getEvaluationData(type);
      if (!data) return false;

      return data.is_submitted === 1 || data.is_submitted === 2;
    },
    fetchEvaluationData() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      axios.get(`/api/evaluations/logbooks/${this.logbookId}`, { headers })
        .then(response => {
          console.log('evaluations response:', response.data);

          if (Array.isArray(response.data)) {
            this.trainee_evaluations = response.data;
          } else if (Array.isArray(response.data?.data)) {
            this.trainee_evaluations = response.data.data;
          } else if (response.data) {
            this.trainee_evaluations = [response.data];
          } else {
            this.trainee_evaluations = [];
          }
        })
        .catch(error => {
          console.error('There was an error fetching the task assessment:', error);
          this.trainee_evaluations = [];
        });
    },
    openEvaluationModal(type) {
      if (type === 'continuous') {
          this.selectedEvaluationType = 'continuous';
          this.selectedParentEvaluationId = null;
          this.selectedEvaluationId = this.continuousEvaluation?.id || null;
          this.selectedFetchedEvaluationData = this.continuousEvaluation || null;
      }

      if (type === 'remedial') {
          if (
          !this.continuousEvaluation ||
          this.continuousEvaluation.is_submitted !== 2 ||
          this.continuousEvaluation.result !== 'remedial'
          ) {
          alert('Remedial evaluation is only available after a submitted continuous evaluation with remedial result.');
          return;
          }

          this.selectedEvaluationType = 'remedial';
          this.selectedParentEvaluationId = this.continuousEvaluation.id;
          this.selectedEvaluationId = this.remedialEvaluation?.id || null;
          this.selectedFetchedEvaluationData = this.remedialEvaluation || null;
      }

      this.showEvaluationModal = true;
    },
    closeEvaluationModal() {
        this.showEvaluationModal = false;
        this.selectedEvaluationType = 'continuous';
        this.selectedParentEvaluationId = null;
        this.selectedEvaluationId = null;
        this.selectedFetchedEvaluationData = null;
        this.fetchEvaluationData();
    },
    isTraineeMissingTask(traineeId) {
      for (const task of this.propTasks) {
        // Check if the task's manob is 'M'
        if (task.manob === 'M' && task.task_status !== 'na') {
          // Check if this trainee has completed this task
          const completion = task.completions.find(completion => completion.trainee_id === traineeId);
          if (!completion || !completion.completed) {
            return true;
          }
        }
      }
      return false;
    },
    getEvaluationButtonClass(type) {
        const data = this.getEvaluationData(type);

        return {
            'pass-button': data?.result === 'successful' && data?.is_submitted === 2,
            'fail-button':
            (
                (type === 'continuous' && data?.result === 'remedial') ||
                (type === 'remedial' && data?.result === 'unsuccessful')
            ) && data?.is_submitted === 2,
            'in-progress-button': data && data.is_submitted !== 2
        };
    },
    getEvaluationButtonLabel(type) {
        const data = this.getEvaluationData(type);

        if (type === 'continuous') {
            if (!data) return 'Start';
            if (data.is_submitted === 0) return 'In Progress';
            if (data.is_submitted === 1) return 'Awaiting Signature';
            if (data.is_submitted === 2 && data.result === 'successful') return 'Passed';
            if (data.is_submitted === 2 && data.result === 'remedial') return 'Remedial';
            return 'View';
        }

        if (type === 'remedial') {
            if (!this.continuousEvaluation || this.continuousEvaluation.result !== 'remedial') {
            return 'Unavailable';
            }
            if (!data) return 'Start';
            if (data.is_submitted === 0) return 'In Progress';
            if (data.is_submitted === 1) return 'Awaiting Signature';
            if (data.is_submitted === 2 && data.result === 'successful') return 'Passed';
            if (data.is_submitted === 2 && data.result === 'unsuccessful') return 'Failed';
            return 'View';
        }

        return 'Start';
    },
    getEvaluationData(type) {
      if (!Array.isArray(this.trainee_evaluations)) return null;
      return this.trainee_evaluations.find(e => e.evaluation_type === type) || null;
    },
  },
  mounted() {
    this.fetchEvaluationData()
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.modal-container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
}

.modal-content {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  padding: 15px;
  border: 1px solid #dddddd;
  border-radius: 3px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-body {
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}

.confirm-button,
.cancel-button {
  padding: 10px 15px;
  margin-left: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-button {
  background-color: #28a745;
  color: white;
}

.cancel-button {
  background-color: #dc3545;
  color: white;
}

.trainee-table {
  width: 100%;
  border-collapse: collapse;
}

.trainee-table th,
.trainee-table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.trainee-table th {
  background-color: #f4f4f4;
}

.Evaluation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.Evaluation-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  margin-top: 2px;
  max-height: 85vh;
  max-width: 90vw;
  min-width: max(60vw, 1000px);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 1002;
}

.modal-title {
  text-align: center;
  margin-bottom: 20px;
}

.container-fluid {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  /* smooth scroll on mobile */
  width: 100%;
}

.evaluation-table {
  width: 90%;
  border-collapse: collapse;
  align-items: center;
  margin: 0 auto;
}

.evaluation-table th,
.evaluation-table td {
  border: 1px solid #ddd;
  padding: 3px 8px;
  text-align: left;
  font-size: 14px;
}

.evaluation-table thead th {
  background-color: #f2f2f2;
  font-size: 15px;
}

.signature-section {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.signature-item label {
  width: 40%;
  display: block;
  margin-bottom: 5px;
}

.signature-placeholder,
.date-placeholder {
  border: 1px solid #ddd;
  padding: 5px;
  min-height: 30px;
  /* Adjust as needed */
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin-top: 20px;
  /* Adjust as needed */
}

.ins-save-button {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
  width: 100%;
  min-width: 90px;
  max-width: 100px;
}

.ins-submit-button {
  background-color: brown;
  border: 1px solid rgb(92, 23, 23);
  color: white;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 20px;
  min-width: 100px;
  max-width: 120px;
  margin-right: 5%;
  height: 35px;
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 5%;
}

.ins-close-button:hover {
  background-color: #4d5358;
}

.ins-clear-button {
  background-color: #f0ac9c;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  margin-right: 0;
  width: 100%;
  min-width: 140px;
  max-width: 150px;
  border: 1px solid #c7715e;
}

.ins-save-button:disabled,
.ins-submit-button:disabled,
.ins-clear-button:disabled {
  background-color: rgb(216, 216, 216);
  cursor: not-allowed;
  color: grey
}

.ins-save-button:disabled:hover,
.ins-submit-button:disabled:hover,
.ins-clear-button:disabled:hover {
  background-color: rgb(216, 216, 216);
  color: grey
}

.ins-submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.evaluation-result {
  margin-left: 25%;
}

.task-performance {
  width: 50%;
  border-collapse: collapse;
  text-align: left;
  background-color: #f2f2f2;
  margin-left: 20px;
}

.task-performance th {
  /* Adjust the color to match your header background */
  font-weight: bold;
}


.task-performance input[type="text"] {
  width: 100%;
  border: none;
  padding: 4px;
  text-align: center;
  background-color: #f2f2f2;
}

.evaluation-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
}


.signature-block {
  display: flex;
  flex-direction: column;
  margin-right: 70px;
}


.signature-table {
  width: 100%;
}

.signature-table td {
  padding: 4px;
  /* Adjust padding as needed */
  vertical-align: middle;
  /* Aligns content of <td> vertically in the middle */
}

.signature-table .signature {
  text-align: left;
  /* Aligns the text to the left */
}

.trainee-signature {
  text-align: left;
}

.signature-table input[type="text"],
.signature-table input[type="date"] {
  width: 100%;
  border: none;
  border-bottom: 1px solid black;
  border-radius: 0px;
  background-color: transparent;
  outline: none;
  height: 20px;
}

@media (max-width: 768px) {

  /* Adjust the max-width as needed for iPad or other tablet sizes */
  .Evaluation-modal {
    padding: 5px;
    font-size: 0.9em;
    /* Reduce font size */
  }

  /* Further adjustments for other elements */
}


#selectAllSatisfactory {
  margin-left: 5px;
  border: 1px solid rgb(206, 13, 13);
}

.signature-pad {
  border-bottom: 1px solid #000;
  border-radius: 5px;
}

.right {
  display: flex;
  justify-content: flex-end;
  margin-right: 5%;
}

/* Add this CSS to your stylesheet */
.signature-image-wrapper {
  position: relative;
  display: inline-block;
}

.signature-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: none;
  /* Prevents interaction with the overlay */
}

.disabled {
  opacity: 0.5;
  /* Optionally reduce opacity to indicate disabled state */
}

.assess-button {
  border: 1px solid #555c57;
  border-radius: 2px;
  background-color: #d6d6d6;
  width: 90px;
}

.assess-button:hover {
  background-color: rgb(180, 180, 180);
}

.assess-button:disabled:hover {
  cursor: not-allowed;
}

.pass-button {
  border: 1px solid #507458;
  border-radius: 2px;
  background-color: #b0e6bd;
  color: #075e1a;
}

.pass-button:hover {
  background-color: #82d896;
}

.fail-button {
  border: 1px solid #745050;
  border-radius: 2px;
  background-color: #e6b0b0;
  color: #7a0606;
}

.fail-button:hover {
  background-color: #d88282;
}

.in-progress-button {
  border: 1px solid #a06e36;
  border-radius: 2px;
  background-color: #e4d09c;
  color: #724400;
}

.in-progress-button:hover {
  background-color: #d8b382;
}

.missing-task {
  background-color: #fce2e4;
  /* Light red background for missing tasks */
}

.fa-window-close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  color: grey;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.fa-window-close:hover {
  color: rgb(87, 87, 87);
  cursor: pointer;
  transform: scale(1.1);
}
</style>